import { render, staticRenderFns } from "./newsa.vue?vue&type=template&id=2ece0994&scoped=true"
import script from "./newsa.vue?vue&type=script&lang=js"
export * from "./newsa.vue?vue&type=script&lang=js"
import style0 from "./newsa.vue?vue&type=style&index=0&id=2ece0994&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece0994",
  null
  
)

export default component.exports